import webIcon from '../../assets/images/icons/web.png';
import gameIcon from '../../assets/images/icons/gameDev.png';
import designIcon from '../../assets/images/icons/design.png';
import blockchainIcon from '../../assets/images/skills/smartcontract.png';

export const SKILLS = [
	{ name: 'Web Dev', icon: webIcon },
	{ name: 'Mobile Dev', icon: gameIcon },
	{ name: 'Blockchain Dev', icon: blockchainIcon },
	{ name: 'UI Design', icon: designIcon },
];
